module.exports = __webpack_public_path__ + "img/xsrw1.425d24cc.png";